import { render, staticRenderFns } from "./SidebarLogos.vue?vue&type=template&id=4da4c38d&scoped=true&"
import script from "./SidebarLogos.vue?vue&type=script&lang=js&"
export * from "./SidebarLogos.vue?vue&type=script&lang=js&"
import style0 from "./SidebarLogos.vue?vue&type=style&index=0&id=4da4c38d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da4c38d",
  null
  
)

export default component.exports